// 获取get\post请求参数
import { stringify } from 'querystring';

function loweredKeys(headers = {}) {
  const lowered = {};
  const keys = Object.keys(headers);

  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    lowered[key.toLowerCase()] = headers[key];
  }
  return lowered;
}


/**
 * API Gateway Client
 */
export default class Base {
  get(url, opts = {}) {
    const parsed = new URL(url);
    const maybeQuery = opts.query || opts.data;
    if (maybeQuery) {
      // Append data into querystring
      const a = Object.assign({}, parsed.query, maybeQuery);
      parsed.query = a;
      parsed.path = `${parsed.pathname}?${stringify(parsed.query)}`;
      // eslint-disable-next-line no-param-reassign
      opts.data = null;
      // eslint-disable-next-line no-param-reassign
      opts.query = null;
    }
    // Lowerify the header key
    // eslint-disable-next-line no-param-reassign
    opts.headers = loweredKeys(opts.headers);
    // eslint-disable-next-line no-param-reassign
    opts.signHeaders = loweredKeys(opts.signHeaders);

    return this.request('GET', parsed, opts);
  }

  post(url, opts = {}) {
    const parsed = new URL(url);
    const {query} = opts;
    if (query) {
      // Append data into querystring
      Object.assign(parsed.query, query);
      parsed.path = `${parsed.pathname}?${stringify(parsed.query)}`;
      // eslint-disable-next-line no-param-reassign
      opts.query = null;
    }

    // Lowerify the header key
    // eslint-disable-next-line no-param-reassign
    opts.headers = loweredKeys(opts.headers);
    // eslint-disable-next-line no-param-reassign
    opts.signHeaders = loweredKeys(opts.signHeaders);

    const {headers} = opts;
    let type = headers['content-type'] || headers['Content-Type'];

    if (!type) {
      headers['content-type'] = 'application/json';
      type = headers['content-type'];
    }

    const originData = opts.data;

    if (type.startsWith('application/x-www-form-urlencoded')) {
      // eslint-disable-next-line no-param-reassign
      opts.data = stringify(opts.data);
    }
    else if (type.startsWith('application/json')) {
      // eslint-disable-next-line no-param-reassign
      opts.data = JSON.stringify(opts.data);
    }
    else if (!Buffer.isBuffer(opts.data) && typeof opts.data !== 'string') {
      // 非buffer和字符串时，以JSON.stringify()序列化
      // eslint-disable-next-line no-param-reassign
      opts.data = JSON.stringify(opts.data);
    }
    return this.request('POST', parsed, opts, originData);
  }

}
